<script setup>
defineProps({
	message: {
		type: String,
		default: null,
	},
});
</script>

<template>
	<div v-if="message" class="error-message w-fit">
		<p class="text-[13px] text-error dark:text-red-400">
			{{ message }}
		</p>
	</div>
</template>
